unable to read source [project]/node_modules/@grpc/proto-loader/src/util.ts